import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import numeral from 'numeral';
import { css } from '@bd/bdui-styles/emotion';
import { Image } from '@bd/bdcore-utilities';
import { Link } from '@bd/bdcore-named-routes';

const styles = css`
  .HMPC_link {
    display: block;
    width: 100%;
    color: black;
    &:hover {
      text-decoration: none;
    }
  }
  .HMPC_image {
    display: block;
    width: 100%;
    height: 161px;
  }
  .HMPC_content {
    padding: 11px;
    display: flex;
  }
  .HMPC_contentText {
    width: 100%;
  }
  .HMPC_homeAddress {
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0.002857em;
    line-height: 1.35;
  }
  .HMPC_homeAddressSm {
    display: block;
    font-size: 11px;
    font-weight: normal;
    letter-spacing: 0.06em;
    text-transform: uppercase;
  }
  .HMPC_price {
    font-size: 13px;
    font-style: italic;
    font-weight: 300;
    margin-top: 3px;
  }
  .HMPC_icon {
    width: 35px;
    height: 35px;
    flex-shrink: 0;
    margin-left: 20px;
  }
`;

function HomeMapPopupCard({ home }) {
  const homePhoto = get(home, 'photos[0]');
  return (
    <div className={styles}>
      <Link className="HMPC_link" name="home-detail" home={home}>
        {
          homePhoto && (
            <Image
              className="HMPC_image"
              src={get(homePhoto, 'contentUrl')}
              alt={get(homePhoto, 'name', '')}
              width={188}
              height={106}
              exact
            />
          )
        }
        <div className="HMPC_content">
          <div className="HMPC_contentText">
            <div className="HMPC_homeAddress">
              {`${get(home, 'address.streetAddress')} `}
              <span className="HMPC_homeAddressSm">
                {get(home, 'address.addressLocality')}, {get(home, 'address.addressRegion')} {get(home, 'address.postalCode')}
              </span>
            </div>
            <div className="HMPC_price">{numeral(get(home, 'price', 0)).format('$0,0')}</div>
          </div>
          <img className="HMPC_icon" src="/images/i-detail-arrow.svg" alt="" />
        </div>
      </Link>
    </div>
  );
}

HomeMapPopupCard.propTypes = {
  home: PropTypes.object.isRequired,
};

export default HomeMapPopupCard;



// WEBPACK FOOTER //
// ./src/components/HomeMapPopupCard.js